// ===================================================
// memoryResurfacing.js — '기억 되살리기' 대상 세션 선정 로직
//
// 동작 방식:
//   1. 전체 기록 중 7~90일 전 사이의 기록을 대상으로 함
//   2. '기록이 적은 날' 기준:
//      - Q&A 라운드가 1개뿐이고 (Continue를 누르지 않은 날)
//      - 모든 답변의 총 글자 수가 100자 미만인 날
//   3. 최근 7일 이내에 이미 기억 되살리기 대상이 됐던 기록은 제외
//   4. 후보 중 가장 기록이 적은 날(총 답변 글자 수 최소)을 선정
// ===================================================


// 기억 되살리기 대상 세션을 선정해서 반환합니다.
//
// allSessions: sessions 상태 객체 (날짜 → 세션 배열)
//   예) { "2026-02-01": [{ id, mode, rounds, ... }], ... }
//
// recentlyResurfacedIds: 최근 7일 이내에 이미 대상이 됐던 세션 ID Set
//   예) new Set(["uuid-1", "uuid-2"])
//
// 반환: 선정된 세션 객체 (date 필드 포함) 또는 null (후보 없을 때)
export function selectSessionForResurfacing(allSessions, recentlyResurfacedIds) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const candidates = [];

  for (const [date, sessionArr] of Object.entries(allSessions)) {
    // 날짜 범위 확인: 7일~90일 전
    const sessionDate = new Date(date + 'T00:00:00');
    const diffDays = Math.floor((today - sessionDate) / (1000 * 60 * 60 * 24));
    if (diffDays < 7 || diffDays > 90) continue;

    for (const session of sessionArr) {
      const rounds = session.rounds || [];

      // 복합 기준: 라운드 1개 AND 총 답변 100자 미만
      if (rounds.length !== 1) continue;
      const totalAnswerLength = (rounds[0].answers || []).join('').length;
      if (totalAnswerLength >= 100) continue;

      // 최근 7일 이내에 이미 대상이 됐던 기록은 제외
      if (recentlyResurfacedIds.has(session.id)) continue;

      candidates.push({ ...session, date, totalAnswerLength });
    }
  }

  if (candidates.length === 0) return null;

  // 가장 답변이 짧은(기록이 적은) 세션을 선정
  candidates.sort((a, b) => a.totalAnswerLength - b.totalAnswerLength);
  return candidates[0];
}
